$(document).ready(() =>
{
	ActionVoicemails.Construct();
});

module ActionVoicemails
{
	const voicemailDocumentIdAttribute = "voicemailid";

	class DownloadRequest {
		DocumentID: string;
		FileName?: string;
		Extension?: string;

		constructor(documentId: string)
		{
			this.DocumentID = documentId;
		}
	}

	class DownloadResponse {
    DownloadUrl: string;
	}

	export function Construct()
	{
		$(`[data-${voicemailDocumentIdAttribute}]`).click(onPlayButtonClicked);
	}

	function onPlayButtonClicked()
	{
		var button = $(this);
		button.addClass("disabled");
		button.text("Loading...");

		var requestData = getrequestData(button);

		$.ajax(
			"/Api/Documents/DownloadUrl",
			{
				data: JSON.stringify(requestData),
				contentType: "application/json; charset=utf-8",
				dataType: "json",
				type: "POST",
				timeout: 5000,
				success: (response: DownloadResponse) => onDownloadUrlObtained(button, response),
				error: () => onFailure(button),
			}
		);
	}

	function getrequestData(button: JQuery<HTMLElement>): DownloadRequest
	{
    var requestData = new DownloadRequest(button.data(voicemailDocumentIdAttribute));
    //This used to include file name but that's not helpful anymore with new Document table
		return requestData;
	}

	function onDownloadUrlObtained(button: JQuery<HTMLElement>, response: DownloadResponse)
	{
		var audio = button.next();
		var source = audio.children().eq(0);
    source.attr("src", response.DownloadUrl);
		var htmlAudio = <HTMLAudioElement>audio[0];
		htmlAudio.load();
		audio.show();
		button.hide();
		htmlAudio.play();
	}

	function onFailure(button: JQuery<HTMLElement>)
	{
		button.removeClass("disabled");
		button.text("Try to play voicemail again");
		Notifications.Warning("Failed to get voicemail.  Please wait a moment and try again.");
	}
}